(function () {
  'use strict';

  var END_SCALE      = 0.55;
  var PHASE1_END     = 0.20; // 0–20 %: text fades in, image stays full-screen
                              // 20–100 %: text fades out + image shrinks simultaneously
  var IMG_RADIUS_MAX = 16;   // px, applied to <img>

  function initShrink(section) {
    if (section.dataset.shrinkInit) return;
    section.dataset.shrinkInit = '1';

    var outer   = section.querySelector('[data-shrink-outer]');
    var img     = section.querySelector('[data-shrink-img]');
    var textEl  = section.querySelector('[data-shrink-text]');
    var overlay = section.querySelector('[data-shrink-overlay]');

    if (!outer || !img) return;

    var outerTop = 0;
    var rafId    = null;
    var lastProg = -1;

    function recalc() {
      outerTop = outer.getBoundingClientRect().top + window.pageYOffset;
    }

    function render() {
      rafId = null;
      var scrolled = window.pageYOffset - outerTop;
      var range    = outer.offsetHeight - window.innerHeight;
      if (range <= 0) return;

      var progress = Math.max(0, Math.min(1, scrolled / range));
      if (Math.abs(progress - lastProg) < 0.0005) return;
      lastProg = progress;

      /* ── Phase 2 progress (0 once phase 1 is done) ── */
      var p2 = Math.max(0, Math.min(1, (progress - PHASE1_END) / (1 - PHASE1_END)));

      /* ── Image: full-screen during phase 1, shrinks in phase 2 ── */
      var scale = 1.0 - (1.0 - END_SCALE) * p2;
      img.style.transform    = 'scale(' + scale.toFixed(4) + ')';
      img.style.borderRadius = (IMG_RADIUS_MAX * p2).toFixed(1) + 'px';

      /* ── Overlay fades out early in phase 2 ── */
      if (overlay) {
        overlay.style.opacity = Math.max(0, 1 - p2 / 0.4).toFixed(3);
      }

      /* ── Text: fade IN phase 1, fade OUT phase 2 ── */
      if (textEl) {
        if (progress <= PHASE1_END) {
          var p1 = progress / PHASE1_END;
          textEl.style.opacity   = p1.toFixed(3);
          textEl.style.transform = 'translateY(' + (20 * (1 - p1)).toFixed(1) + 'px)';
        } else {
          textEl.style.opacity   = (1 - p2).toFixed(3);
          textEl.style.transform = 'translateY(' + (-200 * p2).toFixed(1) + 'px)';
        }
      }
    }

    function onScroll() {
      if (!rafId) rafId = requestAnimationFrame(render);
    }

    recalc();
    render();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { recalc(); render(); });
    window.addEventListener('load',   function () { recalc(); render(); });
  }

  function scanAndInit() {
    document.querySelectorAll('.scroll-shrink').forEach(initShrink);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndInit);
  } else {
    scanAndInit();
  }

  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('scroll-shrink')) initShrink(node);
        node.querySelectorAll && node.querySelectorAll('.scroll-shrink').forEach(initShrink);
      });
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
